module.exports = __webpack_public_path__ + "static/mieszacz-wodno-powietrzny-MWPL-e30cfa1268a79a724afdc8b66c5326e1.pdf";